/**
 * Sticky Add to Cart bar: appears once the real Add to Cart button has
 * scrolled out of view above the viewport. Tapping it forwards a click to
 * the real button, so existing behavior (size-required warning + scroll,
 * actual add-to-cart) runs unchanged with no duplicated logic.
 *
 * While visible, it also pushes the floating tool-bar widget up by its own
 * height via the --sticky-atc-push custom property, so the two don't overlap.
 */
(function () {
  var observers = {};
  var lastVisibleState = {};

  function setPush(bar, visible) {
    var push = visible ? bar.offsetHeight + "px" : "0px";
    document.documentElement.style.setProperty("--sticky-atc-push", push);
  }

  function setUpBar(bar) {
    var sectionId = bar.dataset.section;
    var realButton = document.getElementById("Product-Submit-Button-" + sectionId);
    var stickyButton = bar.querySelector(".sticky-atc-button");
    if (!realButton || !stickyButton) return;

    if (lastVisibleState[sectionId]) {
      bar.classList.add("sticky-atc-bar--visible");
      setPush(bar, true);
    }

    function sync() {
      var realText = realButton.querySelector(".button-text");
      var stickyText = stickyButton.querySelector(".button-text");
      if (realText && stickyText) stickyText.textContent = realText.textContent;
      stickyButton.disabled = realButton.disabled;
      stickyButton.style.fontSize = getComputedStyle(realButton).fontSize;
    }
    sync();

    if (observers[sectionId]) observers[sectionId].disconnect();

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        var isPastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        lastVisibleState[sectionId] = isPastButton;
        bar.classList.toggle("sticky-atc-bar--visible", isPastButton);
        setPush(bar, isPastButton);
      },
      { threshold: 0 },
    );
    observer.observe(realButton);
    observers[sectionId] = observer;

    stickyButton.onclick = function () {
      sync();
      var currentRealButton = document.getElementById("Product-Submit-Button-" + sectionId);
      if (currentRealButton) currentRealButton.click();
    };
  }

  function initAll() {
    document.querySelectorAll(".sticky-atc-bar").forEach(setUpBar);
  }

  document.addEventListener("DOMContentLoaded", initAll);

  if (typeof webvista !== "undefined" && webvista.subscribe) {
    webvista.subscribe(PUB_SUB_EVENTS.variantChange, initAll);
  }
})();
